var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bo_nav_headline", class: { loggedInUser: _vm.isLoggedIn } },
    [
      !_vm.inHeader
        ? [
            _c(
              "div",
              { staticClass: "sb_title" },
              [
                _vm.currentBoNavigation && _vm.currentBoNavigation.imageicon
                  ? _c("icon", {
                      attrs: { name: _vm.currentBoNavigation.imageicon }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("h1", [
                  _vm._v(
                    _vm._s(
                      (_vm.currentBoNavigation &&
                        _vm.currentBoNavigation.name) ||
                        _vm.title
                    )
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.currentBoNavigation &&
                    (_vm.currentBoNavigation.description ||
                      _vm.currentBoNavigation.internaldescription)
                )
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.inHeader
        ? [
            _c("h1", [
              _vm._v(
                _vm._s(
                  (_vm.currentBoNavigation && _vm.currentBoNavigation.name) ||
                    _vm.title
                )
              )
            ]),
            _vm._v(" "),
            !(_vm.currentBoNavigation && _vm.currentBoNavigation.name) &&
            _vm.pageTitle
              ? _c(
                  "h1",
                  { class: { "title-live": _vm.pageTitle === "live" } },
                  [
                    _vm._v(_vm._s(_vm.$t("PageTitle." + _vm.pageTitle)) + " "),
                    _vm.pageTitle === "live"
                      ? _c("icon", { attrs: { name: "icon-live" } })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.liveEvent
              ? _c(
                  "h1",
                  { staticClass: "title-live" },
                  [
                    _vm._v(_vm._s(_vm.$t("PageTitle.live")) + " "),
                    _c("icon", { attrs: { name: "icon-live" } })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39f0dd94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f0dd94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/SportsBreadcrumb.vue
// module id = null
// module chunks = 